import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiListModule } from "@snelstart/ui-list";
import { SharedUiLoadingModule } from "@snelstart/ui-loading";
import { SharedUiOffCanvasModule } from "@snelstart/ui-off-canvas";
import { BezwaarComponent } from "./bezwaar/bezwaar.component";
import {FeatureTaxBezwaarDetailsComponent} from "./tax-bezwaar-details/feature-tax-bezwaar-details.component";
import {SharedUiIconModule} from "@snelstart/ui-icon";
import {SharedUiTooltipModule} from "@snelstart/ui-tooltip";
import {SharedUiFileUploadModule} from "@snelstart/ui-file-upload";
import {SharedUiAlertModule} from "@snelstart/ui-alert";
import {SharedUiContextMenuModule} from "@snelstart/ui-context-menu";

@NgModule({
  imports: [
    CommonModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDialogModule,
    SharedUiListModule,
    SharedUiLoadingModule,
    SharedUiOffCanvasModule,
    BezwaarComponent,
    SharedUiIconModule,
    SharedUiTooltipModule,
    SharedUiFileUploadModule,
    SharedUiAlertModule,
    SharedUiContextMenuModule,
    FeatureTaxBezwaarDetailsComponent
  ],
  declarations: [

  ],
  exports: [FeatureTaxBezwaarDetailsComponent],
})
export class FeatureTaxBezwaarDetailsModule {}
